import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 10 9",
  "content": "<symbol viewBox=\"0 0 10 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-up\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.36388 1.50967C4.74488 0.823859 5.73119 0.823857 6.11219 1.50967L9.41268 7.45054C9.78297 8.11707 9.30101 8.93618 8.53852 8.93618H1.93755C1.17507 8.93618 0.693099 8.11707 1.06339 7.45054L4.36388 1.50967Z\" fill=\"#766E68\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol